module.exports = __webpack_public_path__ + "static/media/tutorial2.b061cba8.jpg";